(function() { window.GUID_6f9892e6_b740_41de_8878_c747346f408d = { getGuid: function() { return "6f9892e6-b740-41de-8878-c747346f408d"; } }; })();
var CS;
(function (CS) {
    CS.SetCalendarRegionalSettings();
    class Calendar {
        constructor(inputBox, isCalendarPicker) {
            this.SelectionChange = null;
            this.isCalendarPicker = isCalendarPicker;
            this.uiDiscovery(inputBox);
            this.bindEvent();
        }
        uiDiscovery(inputBox) {
            if (!this.isCalendarPicker) {
                this.yearRange = "-100:+5";
            }
            else {
                this.yearRange = undefined;
            }
            this.InputBox = inputBox;
            this.InputBox.data('context', this);
            this.DatePickerId = inputBox[0].id;
            this.CSDatePicker = inputBox.datepicker({
                changeMonth: true,
                changeYear: true,
                numberOfMonths: 1,
                yearRange: this.yearRange,
                beforeShowDay: function (d) {
                    //ScheduleDates vient de la des vues qui applique JSArrayHelper 
                    if (typeof ScheduledDates !== 'undefined' && ScheduledDates != null) {
                        var year = d.getFullYear();
                        var month = d.getMonth() + 1;
                        var day = d.getDate();
                        if (month.toString().length == 1) {
                            month = '0' + month;
                        }
                        if (day.toString().length == 1) {
                            day = '0' + day;
                        }
                        var result = year + '-' + month + '-' + day;
                        if ($.inArray(result, ScheduledDates) != -1) {
                            //[0] = true/false (isEnable or not                //[1] = CSS class                //[2] = tooltip
                            return [true, "HighlightedDayDatePicker", "Available"];
                        }
                        else {
                            return [true, "NotHighlightedDayDatePicker", "unAvailable"];
                        }
                    }
                    else {
                        return [true, "NotHighlightedDayDatePicker", "unAvailable"];
                    }
                },
                showButtonPanel: !this.isCalendarPicker
            });
            if (this.isCalendarPicker) {
                this.defaultStartDate = this.InputBox.data('selecteddate');
                this.CSDatePicker.datepicker('setDate', this.defaultStartDate);
            }
            this.ActualSelectedDate = this.CSDatePicker.datepicker('getDate');
        }
        bindEvent() {
            let me = this;
            this.InputBox.on('keyup', function (e) {
                if (e.keyCode == 13) {
                    me.InputBox.trigger('blur');
                }
            }).on('change', function () {
                let newStartDate = me.CSDatePicker.datepicker('getDate');
                if (newStartDate != null && (me.ActualSelectedDate == null || newStartDate.toString() != me.ActualSelectedDate.toString()) || me.isCalendarPicker) {
                    if (me.ActualSelectedDate != null) {
                        var diffYear = me.ActualSelectedDate.getFullYear() - newStartDate.getFullYear();
                        var diffMonth = me.ActualSelectedDate.getMonth() - newStartDate.getMonth();
                        var diffDay = me.ActualSelectedDate.getDate() - newStartDate.getDate();
                        me.OffsetYear = diffYear;
                        me.OffsetMonth = diffMonth;
                        me.OffsetDay = diffDay;
                    }
                    else {
                        me.OffsetYear = 0;
                        me.OffsetMonth = 0;
                        me.OffsetDay = 0;
                    }
                    me.ActualSelectedDate = newStartDate;
                    if (me.SelectionChange != null) {
                        me.SelectionChange.call(me);
                    }
                    me.InputBox.trigger("CSChange", me);
                    if (!me.isCalendarPicker) {
                        $('.DummyInput').focus();
                    }
                }
            });
        }
        val(newVal) {
            if (newVal != null) {
                this.InputBox.datepicker('setDate', newVal);
                this.InputBox.trigger('change');
            }
            else {
                return this.InputBox.val();
            }
        }
    }
    CS.Calendar = Calendar;
})(CS || (CS = {}));

//# sourceMappingURL=cs.calendar.js.map
